import { render, staticRenderFns } from "./EcoTransesofageaEditComponent.vue?vue&type=template&id=555c2f12&scoped=true"
import script from "./EcoTransesofageaEditComponent.vue?vue&type=script&lang=js"
export * from "./EcoTransesofageaEditComponent.vue?vue&type=script&lang=js"
import style0 from "./EcoTransesofageaEditComponent.vue?vue&type=style&index=0&id=555c2f12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "555c2f12",
  null
  
)

export default component.exports